import { render, staticRenderFns } from "./footBox.vue?vue&type=template&id=80db4f80&scoped=true"
import script from "./footBox.vue?vue&type=script&lang=js"
export * from "./footBox.vue?vue&type=script&lang=js"
import style0 from "./footBox.vue?vue&type=style&index=0&id=80db4f80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80db4f80",
  null
  
)

export default component.exports